import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';

/**
 * Whether this deployment sells credits rather than time-limited licenses.
 *
 * Decided server-side: the credit account endpoint only describes a purchase
 * package when the credit system is enabled. Returns null while detecting, so
 * callers can avoid flashing the wrong product's UI.
 */
export default function useCreditMode() {
  const { token } = useAuth();
  const [creditMode, setCreditMode] = useState(null);

  useEffect(() => {
    let cancelled = false;
    if (!token) { setCreditMode(false); return undefined; }
    (async () => {
      try {
        const response = await fetch(`${API_BASE}/api/credits/account`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = response.ok ? await response.json() : null;
        if (!cancelled) setCreditMode(!!(data && data.purchase_package));
      } catch (err) {
        if (!cancelled) setCreditMode(false);
      }
    })();
    return () => { cancelled = true; };
  }, [token]);

  return creditMode;
}
